import { Component, OnInit, ViewContainerRef, ViewChild } from '@angular/core';
import { PoBranch } from '../pos/poBranch';
import { Observable } from 'rxjs/Observable';
import { Branch } from '../../accounting/branch';
import { PoService } from '../pos/po.service';
import { Location } from '@angular/common';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { TdDataTableService, ITdDataTableSortChangeEvent, IPageChangeEvent, ITdDataTableColumn, TdDataTableSortingOrder, TdDialogService, TdLoadingService, TdPagingBarComponent } from '@covalent/core';
import { InventoryService } from '../../inventory/inventory.service';
import { Piece } from '../../inventory/piece';
import { AuthenticationService } from '../../../shared/services/authentication.service';
import { SalesService } from '../../sales/sales.service';
import { Sale } from '../../sales/sale';
import { SettingsService } from '../../../shared/services/settings.service';
import { BranchService } from '../../accounting/branches/branch.service';
import { Supplier } from '../suppliers/supplier';
import { ReportService } from '../../../shared/services/report.service';
import { PoOrder } from '../pos/po-orders';
import {Utils} from '../../../shared/utils';

@Component({
  selector: 'app-po-branch-to-branch',
  templateUrl: './po-branch-to-branch.component.html',
  styleUrls: ['./po-branch-to-branch.component.scss'],
  providers: [ReportService]
})
export class PoBranchToBranchComponent implements OnInit {
  @ViewChild('pagingBar') pagingBar: TdPagingBarComponent;
  currentBranchPo: PoBranch;

  originalBranchPo: PoBranch;

  title: string = "Branch to Branch Transfer Request";
  isEditMode: boolean;

  allBranches: Branch[] = [];
  allStatuses$: Observable<string[]>;

  existingInventory: Piece[];

  loading: boolean = false;

  columns_transfer: ITdDataTableColumn[] = [
    { name: 'collection', label: 'Collection', tooltip: 'some tooltip example' },
    { name: 'designColor', label: 'Design / Color' },
    { name: 'pieceNo', label: 'Piece #' },
    { name: 'lotNo', label: 'Lot #' },
    { name: 'length', label: 'Length (M)' },
    { name: 'weight', label: 'Weight (Kg)' },
  ];

  columns_existing: ITdDataTableColumn[] = this.columns_transfer.concat({ name: 'location', label: 'Location' });

  prepared_items: Piece[] = [];

  items_not_prepared: Piece[] = [];

  items: Piece[] = [];
  filteredData: any[] = [];
  filteredTotal: number;
  searchTerm: string;
  fromRow: number = 1;
  currentPage: number = 1;
  //pageSize: number = 5;
  sortBy: string = 'id';
  selectedRows: any[];
  sortOrder: TdDataTableSortingOrder = TdDataTableSortingOrder.Ascending;

  availableStatuses: string[];

  _src_branch: Branch;
  _dst_branch: Branch;

  saving: boolean = false;
  sales_pending: boolean = false;

  constructor(private _poService: PoService,
    private route: ActivatedRoute,
    private router: Router,
    private location: Location,
    private _viewContainerRef: ViewContainerRef,
    private _loadingService: TdLoadingService,
    private _dialogService: TdDialogService,
    public _authService: AuthenticationService,
    private _salesService: SalesService,
    private _branchService: BranchService,
    private _reportService: ReportService,
    public _settingsService: SettingsService,
    private _dataTableService: TdDataTableService,
    private _inventoryService: InventoryService) { }

  ngOnInit(): void {
    this._loadingService.register('loading');

    this.route.paramMap
      .switchMap((params: ParamMap) => params.get('id')
        ? this.processEdit(params.get('id'))
        : this.processNew())
      .subscribe((currentBranchPo: PoBranch) => {
        this.currentBranchPo = currentBranchPo;

        this.originalBranchPo = Object.assign({}, this.currentBranchPo);

        // If it was an existing PO retrieve items
        if (this.currentBranchPo.po_id != null) {
          this.title = this.currentBranchPo.po_number;

          this._poService.getBranchPoItems(currentBranchPo.po_id + '').subscribe(
            response => {
              this.items = response;
              this.filter();
            }
          );

          // If it is in PREPARED or SHIPPED, get the not shipped items
          this._poService.getBranchPoNotPreparedItems(this.currentBranchPo.po_id + '').subscribe(
            response => {
              this.items_not_prepared = response;
              this.filter();

              console.log(this.items_not_prepared);
            }
          );

          if (this.currentBranchPo.status == 'DRAFT') {
            // If this was stored as a DRAFT, we are pending the SALES ORDER
            this.sales_pending = true;
          }

          // Get Items
          if (this.isOrdered()) {
            this._salesService.getOneSaleByOrderNumber(this.currentBranchPo.po_number).subscribe(
              (s: Sale) => {
                this._salesService.getSaleItems(s.id + '').subscribe(
                  items => {
                    this.prepared_items = items;
                  }
                );
              }
            );
          }

          this.availableStatuses = this.getAvailableStatuses();
        } else {
          // For new POs, default the TO branch to the user's home branch
          this.currentBranchPo.requesting_branch_id = this._authService.getHomeBranch();

          this.availableStatuses = this.getAvailableStatuses();
        }
        this.displaySelectedBranches();
        this._loadingService.resolve('loading');

      });

    this.getBranches();
    //this.allStatuses$ = this._poService.getStatuses();
  }

  getBranches() {
    this._branchService.getBranches().subscribe(
      response => {
        this.allBranches = response;
      },
      error => {
        this.allBranches = [];
      },
      () => {
        this.displaySelectedBranches();
      }
    );
  }

  changed(): boolean {
    for (let prop in this.currentBranchPo) {
      if (this.currentBranchPo[prop] != this.originalBranchPo[prop]) {
        return true;
      }
    }

    return false;
  }

  printPO() {
    this._branchService.getBranch(this.currentBranchPo.requesting_branch_id).subscribe(
      (rBranch: Branch) => {
        this._branchService.getBranch(this.currentBranchPo.source_branch_id).subscribe(
          (sBranch: Branch) => {
            let poItemList: PoOrder[] = [];

            this.items.forEach(
              i => {
                poItemList.push(Object.assign(new PoOrder(), {
                  collection_name: i.collection_name,
                  design_name: i.design_name,
                  color_name: i.color_name,
                  quantity: i.length,
                  unit_price: 0,
                })
                );
              }
            );


            this._reportService.purchaseOrderReport(this.currentBranchPo, poItemList, rBranch, new Supplier(), false, sBranch);
          }
        );
      }
    );
  }

  displaySelectedBranches() {
    if (!this.currentBranchPo) return;
    // Set the options right when we get all branches
    for (let i = this.allBranches.length - 1; i >= 0; i--) {
      if (this.allBranches[i].id == this.currentBranchPo.source_branch_id) {
        this._src_branch = this.allBranches[i];
        // Also load inventory
        this.updateInventory(this.currentBranchPo.source_branch_id);
      }
      //if (this.allBranches[i].id == this.currentBranchPo.requesting_branch_id) this._dst_branch = this.allBranches[i];
    }
    //this._dst_branch = this._authService.getUserBranches().find((b: Branch) => { return b.id == this._authService.getHomeBranch() });
    this._dst_branch = this._authService.getUserBranches().find((b: Branch) => { return b.id == this.currentBranchPo.requesting_branch_id });
  }

  processEdit(po_number: string): Observable<PoBranch> {
    this.title = 'edit';
    this.isEditMode = true;
    return this._poService.getOnePoBranch(po_number);
  }

  processNew(): Observable<PoBranch> {
    this.title = 'New Branch to Branch Transfer Request';
    this.isEditMode = false;
    return Observable.of(new PoBranch());
  }

  updateInventory($event) {
    this._inventoryService.getPieces($event, null).subscribe(
      response => {
        this.existingInventory = response;
        this.filter();
      }
    );
  }

  total(data: any[], field: string) {
    return data.reduce(function (a, b) { return Number.parseFloat(a) + Number.parseFloat(b[field]) }, 0);
  }

  totalChecked(data: any[], field: string) {
    return data.reduce(function (a, b) { return Number.parseFloat(a) + Number.parseFloat(b['selected'] ? b[field] : 0) }, 0);
  }

  getBranch(id_ref: string) {

  }

  sameId(o1: any, o2: any): boolean {
    return o1 && o2 && o1.id === o2.id;
  }

  toggleSelectAll(value: boolean) {
    this.filteredData.forEach(
      function (d) {
        d.selected = value;
      }
    );
  }

  shouldSelectAll(): boolean {
    return this.filteredData.filter(
      function (d) {
        return d.selected
      }
    ).length == this.filteredData.length;
  }

  selectTagAll() {
    // If all are tagged
    if (this.allTagged()) {
      this.items.forEach(i => { i['selected'] = false });
    } else {
      this.items.forEach(i => { i['selected'] = true });
    }
  }

  allTagged() {
    return (this.items.length == this.items.filter(i => { return i['selected'] }).length);
  }

  addTag() {
    this._dialogService.openPrompt({
      title: 'Enter tag',
      message: 'Enter tag to be associated to this piece'
    }).afterClosed().subscribe(
      tag => {
        if (tag) {
          this.items.filter(i => { return i['selected'] }).forEach(p => { p['tag'] = tag });
        }
      }
    );
  }

  displayTag(tag) {
    this._dialogService.openAlert({
      title: 'VIEW TAG',
      message: tag,
      closeButton: 'OK'
    })
  }

  addItemsToTransfer(items) {
    items.forEach(
      (i) => {
        if (i.selected) {
          this.items.push(i);
          i.selected = false;
        }
      }
    );
    //this.filterTransfer();
    this.filter();
  }

  removeItem(id: number) {
    this.items = this.items.filter(function (t) { return t.id != id });
  }

  createTransfer() {
    // Avoid double-click issues
    if (this.saving) return;

    this._loadingService.register('loading');

    // If the branch code is not set
    if (this.currentBranchPo.requesting_branch_code == null) {
      this.currentBranchPo.requesting_branch_code = this.allBranches.find((b) => { return b.id == this.currentBranchPo.requesting_branch_id }).code;
    }

    this.currentBranchPo.transferItems = this.items;
    this._poService.createBranchPo(this.currentBranchPo).subscribe(
      response => {
        if (response['status'] == 'SUCCESS') {
          this.currentBranchPo.po_id = response['id'];
          this.currentBranchPo.po_number = response['po_number'];

          this.originalBranchPo = Object.assign({}, this.currentBranchPo);

          this.isEditMode = true;

          this._dialogService.openAlert({
            message: 'Purchase Order ' + this.currentBranchPo.po_number + ' created successfully!',
            title: 'Success!',
          }).afterClosed().subscribe((accept: boolean) => {
            // If we do create it as ORDERED we need to create the sales order
            if (this.currentBranchPo.status == 'ORDERED') {
              this.createSalesOrder(true);
            } else {
              this._loadingService.resolve('loading');
              this.saving = false;

              this.router.navigate(['/purchasing', 'po']);
            }
          });
        } else {
          this._dialogService.openAlert({
            message: 'Could not create Branch Transfer' + this.currentBranchPo.po_number + '.',
            title: 'Failed!',
          });
        }
      },
      error => {
        this._dialogService.openAlert({
          message: 'Error creating Branch Transfer ' + this.currentBranchPo.po_number + ': ' + error,
          title: 'Error!',
        });

        this._loadingService.resolve('loading');
        this.saving = false;
      },
      () => { }
    );
  }

  saveTransfer() {
    // Avoid double-click issues
    if (this.saving) return;

    this._loadingService.register('loading');
    this.saving = true;

    this.currentBranchPo.transferItems = this.items;

    // Call the "ID" "Piece_ID"
    this.currentBranchPo.transferItems.forEach(p => { if (p.piece_id == null) p.piece_id = p.id });
    this._poService.updateBranchPo(this.currentBranchPo.po_id, this.currentBranchPo).subscribe(
      response => {
        if (response['status'] == 'SUCCESS') {
          this.originalBranchPo = Object.assign({}, this.currentBranchPo);

          this._dialogService.openAlert({
            message: 'Branch Transfer ' + this.currentBranchPo.po_number + ' updated successfully!',
            title: 'Success!',
          }).afterClosed().subscribe((accept: boolean) => {
            // If we are saving as ORDERED and we came from DRAFT, need to create the sales order as not new
            if (this.currentBranchPo.status == 'ORDERED' && this.sales_pending) {
              this.createSalesOrder(false);
            } else if (this.currentBranchPo.status == 'ORDERED') {
              this.updateSalesOrder(this.currentBranchPo.po_number);
            } else {
              this.router.navigate(['/purchasing', 'po']);

              this._loadingService.resolve('loading');
              this.saving = false;
            }
          });
        } else {
          this._dialogService.openAlert({
            message: 'Could not update Branch Transfer ' + this.currentBranchPo.po_number + '.',
            title: 'Failed!',
          });
          this._loadingService.resolve('loading');
          this.saving = false;
        }
      },
      error => {
        this._dialogService.openAlert({
          message: 'Error updating Branch Transfer ' + this.currentBranchPo.po_number + ': ' + error,
          title: 'Error!',
        });
        this._loadingService.resolve('loading');
        this.saving = false;
      },
      () => { }
    );
  }

  createAndSendTransfer() {
    this.currentBranchPo.status = 'ORDERED';
    this.createTransfer();
  }

  createSalesOrder(newPo: boolean) {
    let _sale: Sale = new Sale();

    _sale.order_number = this.currentBranchPo.po_number;

    _sale.order_date = this.currentBranchPo.order_date;
    _sale.delivery_date = this.currentBranchPo.estimated_arrival_date;
    _sale.type = 'B2B';
    //branch_id -> Who sources the  items
    _sale.branch_id = this.currentBranchPo.source_branch_id;
    //_sale.branch_id = this.currentBranchPo.requesting_branch_id;
    _sale.requesting_branch_id = this.currentBranchPo.requesting_branch_id;
    _sale.status = 'RESERVED';

    // Add the notes as Sales Order notes
    _sale.notes = this.currentBranchPo.notes;

    this.items.forEach(
      function (i) {
        // A just created PO uses "id" as the ID for the piece, whereas a come-back PO calls that "piece_id"
        if (newPo) {
          _sale.items.push({
            id: i.id,
            quantity: i.length,
            unit_price: 0,
            tag: i.tag
          });
        } else {
          _sale.items.push({
            id: i.piece_id,
            quantity: i.length,
            unit_price: 0,
            tag: i.tag
          });
        }
      }
    );

    this._salesService.createSale(_sale).subscribe(
      response => {
        this._dialogService.openAlert({
          message: 'A sales order has been created',
          title: 'Info',
        }).afterClosed().subscribe(
          result => {
            this.router.navigate(['/purchasing', 'po'])
          }
        );
        this._loadingService.resolve('loading');
        this.saving = false;
      },
      error => {
        this._loadingService.resolve('loading');
        this.saving = false;
      }
    );
  }

  updateSalesOrder(order_number: string) {
    this._salesService.getOneSaleByOrderNumber(order_number).subscribe(
      salesOrder => {
        salesOrder.items = [];
        this.items.forEach(
          function (i) {
            // A just created PO uses "id" as the ID for the piece, whereas a come-back PO calls that "piece_id"
            salesOrder.items.push({
              id: i.piece_id,
              quantity: i.length,
              unit_price: 0,
              tag: i.tag
            });
          }
        );

        salesOrder.notes = this.currentBranchPo.notes;

        this._salesService.updateSale(salesOrder.id, salesOrder).subscribe(
          response => {
            this._dialogService.openAlert({
              message: 'The sales order has been updated',
              title: 'Info',
            }).afterClosed().subscribe(
              result => {
                this.router.navigate(['/purchasing', 'po'])
              }
            );
            this._loadingService.resolve('loading');
            this.saving = false;
          },
          error => {
            this._loadingService.resolve('loading');
            this.saving = false;
          }
        );
      },
      error => {
        this._loadingService.resolve('loading');
        this.saving = false;
      }
    );
  }

  preparedStatusText() {
    let totalPieces: number = this.prepared_items.length;
    let preparedPieces: number = this.prepared_items.filter(p => { return p.prepared_pallet_id }).length;
    let totalMeters: number = this.prepared_items.reduce((a, b) => { return a + b.quantity }, 0);
    let preparedMeters: number = this.prepared_items.filter(p => { return p.prepared_pallet_id }).reduce((a, b) => { return a + b.quantity }, 0);

    return preparedPieces + '/' + totalPieces + ' pieces prepared, ' + parseFloat(preparedMeters.toString()).toFixed(2) + '/' + parseFloat(totalMeters.toString()).toFixed(2) + ' meters prepared';
  }

  preparedStatusValue() {
    let totalPieces: number = this.prepared_items.length;
    let preparedPieces: number = this.prepared_items.filter(p => { return p.prepared_pallet_id }).length;
    //let totalMeters: number = this.prepared_items.reduce((a, b) => { return a + b.quantity }, 0);
    //let preparedMeters: number = this.prepared_items.filter(p => { return p.prepared_location_id }).reduce((a, b) => { return a + b.quantity }, 0);

    return (preparedPieces / totalPieces) * 100;
  }

  enterNewValueDialog(row: Piece, attr: string) {
    this._dialogService.openPrompt({
      message: 'Enter new value',
      viewContainerRef: this._viewContainerRef,
      title: 'Modify value',
      value: row[attr],
      cancelButton: 'Cancel',
      acceptButton: 'Apply',
    }).afterClosed().subscribe((newValue: string) => {
      if (newValue) {
        row[attr] = newValue;
      } else {
        console.log('cancelled');
      }
    });
  }

  sort(sortEvent: ITdDataTableSortChangeEvent): void {
    this.sortBy = sortEvent.name;
    this.sortOrder = sortEvent.order;
    this.filter();
  }

  search(searchTerm: string): void {
    this.searchTerm = searchTerm;
    this.filter();
  }

  page(pagingEvent: IPageChangeEvent): void {
    console.log(pagingEvent)
    this.fromRow = pagingEvent.fromRow;
    this.currentPage = pagingEvent.page;
    this._settingsService.setPageSize(pagingEvent.pageSize);
    this.filter();
  }

  pageTransfer(pagingEvent: IPageChangeEvent): void {
    this.fromRow = pagingEvent.fromRow;
    this.currentPage = pagingEvent.page;
    this._settingsService.setPageSize(pagingEvent.pageSize);
    this.filterTransfer();
  }

  getAvailableStatuses(): string[] {
    // On new entry only DRAFT
    if (this.isEditMode == false) {
      return ['DRAFT', 'ORDERED'];
    }

    switch (this.currentBranchPo.status) {
      // If it was draft, can be DRAFT, ORDERED
      case 'DRAFT':
        return ['DRAFT', 'ORDERED', 'CANCELLED'];

      // The rest of the statuses are managed automatically
      default:
        return [this.currentBranchPo.status];
    }

  }

  isDraft(): boolean {
    if (this.currentBranchPo == null) return false;

    switch (this.currentBranchPo.status) {
      case 'DRAFT':
      case 'ORDERED':
      case 'CANCELLED':
      case 'APPROVED':
      case 'PREPARED':
      case 'SHIPPED':
      case 'RECEIVED':
        return true;
      default:
        return false;
    }
  }

  isCancelled(): boolean {
    if (this.currentBranchPo == null) return false;

    switch (this.currentBranchPo.status) {
      case 'CANCELLED':
        return true;
      default:
        return false;
    }
  }

  isOrdered(): boolean {
    if (this.currentBranchPo == null) return false;

    switch (this.currentBranchPo.status) {
      case 'DRAFT':
        return false;
      case 'ORDERED':
      case 'CANCELLED':
      case 'APPROVED':
      case 'PREPARED':
      case 'SHIPPED':
      case 'RECEIVED':
        return true;
      default:
        return false;
    }
  }

  isPrepared(): boolean {
    if (this.currentBranchPo == null) return false;

    switch (this.currentBranchPo.status) {
      case 'DRAFT':
      case 'ORDERED':
      case 'CANCELLED':
      case 'APPROVED':
      case 'SHIPPED':
        return false;
      case 'PREPARED':
      case 'RECEIVED':
        return true;
      default:
        return false;
    }
  }

  isReceived(): boolean {
    if (this.currentBranchPo == null) return false;

    switch (this.currentBranchPo.status) {
      case 'DRAFT':
      case 'ORDERED':
      case 'CANCELLED':
      case 'APPROVED':
      case 'PREPARED':
      case 'SHIPPED':
        return false;
      case 'RECEIVED':
        return true;
      default:
        return false;
    }
  }

  filter(): void {
    let newData: any[] = this.existingInventory ? this.existingInventory : [];
    newData = newData.filter((item) => { return this.items.find((entry) => { return entry.id == item.id }) == null })
    //newData = this._dataTableService.filterData(newData, this.searchTerm, true);
    // Filter as an AND
    newData = newData.filter((d) => {
      let _search: string = (this.searchTerm || '');

      return (d.design_name + '/' + d.color_name).toLowerCase().indexOf(_search.toLowerCase()) > -1;
    });

    this.filteredTotal = newData.length;
    //newData = this._dataTableService.sortData(newData, this.sortBy, this.sortOrder);
    // Always alphabetical order on COLLECTION, then DESIGN, then COLOR
    newData = newData.sort(
      (a, b) => {
        /*
        return (a['collection_name'] != b['collection_name']) ?
          ((a['collection_name'] > b['collection_name']) ? 1 : -1) :
          ((a['design_name'] != b['design_name']) ?
            ((a['design_name'] > b['design_name']) ? 1 : -1) :
            ((a['color_name'] > b['color_name']) ? 1 : -1))
            */
        // ignore collection on sort, only design then color
        return (a['design_name'] != b['design_name']) ?
          ((a['design_name'] > b['design_name']) ? 1 : -1) :
          ((a['color_name'] > b['color_name']) ? 1 : -1);
      }
    );

    if (this._settingsService.getPageSize() + '' != 'All') {
      newData = this._dataTableService.pageData(newData, this.fromRow, this.currentPage * this._settingsService.getPageSize());
    }
    this.filteredData = newData;

    //Go back to page 1 if we are beyond limit
    if (this.filteredTotal && this.filteredTotal > 0 && this.fromRow > this.filteredTotal) {
      this.pagingBar.firstPage();
    }

  }

  filterTransfer(): void {
    let newData: any[] = this.items;
    //newData = this._dataTableService.filterData(newData, this.searchTerm, true);
    this.filteredTotal = newData.length;
    newData = Utils.sortData(newData, this.sortBy, this.sortOrder);
    if (this._settingsService.getPageSize() + '' != 'All') {
      newData = this._dataTableService.pageData(newData, this.fromRow, this.currentPage * this._settingsService.getPageSize());
    }
    this.items = newData;
  }

  goBack(): void {
    this.location.back();
  }

}



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/app/agatextscreens/purchasing/po-branch-to-branch/po-branch-to-branch.component.ts